export default "/img/AW.23d6aa8caffade374ef13974882facf6.png";